import { ResponsiveContext } from 'grommet';
import { Project } from 'lib/api';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { useCommercialStore, useUsageStore } from 'src/context';
import { shortenCurrency, USD } from 'src/utils/currency';
import { AddNewButton } from '../AddNewButton';
import { BulkDeleteButton } from '../BulkDeleteButton';
import { SaveStatus } from '../SaveStatusIndicator';
import { HeaderTotal, PageHeader } from '../PageHeader';

export type UsageEstimatorHeaderProps = {
  project?: Project;
  onCreateCommercial: () => void;
  onDeleteCommercials: () => void;
  /** How many commercials are checked; their delete button shows once there's one */
  selectedCommercialCount: number;
  totalWages?: number;
  grandTotal?: number;
};

export const UsageEstimatorHeader = observer(
  ({
    project,
    onCreateCommercial,
    onDeleteCommercials,
    selectedCommercialCount,
    totalWages,
    grandTotal,
  }: UsageEstimatorHeaderProps) => {
    /** Context **/
    const commercialStore = useCommercialStore();
    const usageStore = useUsageStore();
    const screenSize = useContext(ResponsiveContext);
    const isDesktop = screenSize === 'large';

    /** Computed **/
    const saveStatus = usageStore.isSaving || commercialStore.isSaving ? SaveStatus.Saving : SaveStatus.Saved;

    /** Render **/
    return (
      <PageHeader
        title={project ? `${project.name} Usages` : 'Usage Estimator'}
        saveStatus={saveStatus}
        actions={
          <>
            <AddNewButton onClick={onCreateCommercial} label="New commercial" />
            <BulkDeleteButton
              count={selectedCommercialCount}
              singular="commercial"
              plural="commercials"
              onDelete={onDeleteCommercials}
              confirm={false}
            />
          </>
        }
        totals={
          <>
            <HeaderTotal label="Total wages" value={(!isDesktop ? shortenCurrency : USD)(totalWages)} />
            <HeaderTotal label="Grand total" value={(!isDesktop ? shortenCurrency : USD)(grandTotal)} grand />
          </>
        }
      />
    );
  }
);
